import StatusMobileNumberNotice from "./status-mobile-number-notice";
import { useContext } from "react";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { isStatusBlockedWithoutPhone } from "@/modules/lead-page/utils/status-mobile-number";
import { getJourneyStatusesResponse } from "@/modules/common/dtos/index.v2";
import FormRenderer from "@/modules/lead-page/components/lead-info/edit-fields/status/form-renderer";
import StatusSelector from "@/modules/lead-page/components/lead-info/edit-fields/status/status-selector";
import useEditStatusForm from "@/modules/lead-page/hooks/lead-info/status/edit-status-form.hook";
import { muiTheme } from "@/styles/theme";
import { CircularProgress, Box, Alert, Button } from "@mui/material";
import TrackSelectionModal from "@/modules/lead-page/new/components/activity/track-selection-modal";
const EditStatusForm: React.FC<{
  handleConfirmUpdate: (values: any) => Promise<void>;
  isLoadingSubmition: boolean;
  status: {
    editLeadStatusModalOpen: boolean;
    setEditLeadStatusModalOpen: (value: boolean) => void;
    handleChangeStatus: (event: any) => void;
    handleChangeStatusComment: (event: any) => void;
    statusChangeComment: string;
    data: { data: getJourneyStatusesResponse[] };
    state: string | null;
    statusName: string;
  };
 
  onOpenCreateTrack?: () => void;
}> = ({
  handleConfirmUpdate,
  isLoadingSubmition,
  status,
  onOpenCreateTrack,
}) => {
  const {
    selectedStatus,
    formFields,
    isLoadingForm,
    handleSubmit,
    getSaleType,
    setStatusFormUId,
    handleDeleteFile,
    handleFiles,
    files,
    paymentFiles,
    paymentPlanFiles,
    handlePaymentFiles,
    handlePaymentPlanFiles,
    handleDeletePaymentFiles,
    tracks,
    isLoadingTracks,
    disableSaveForTrack,
    trackBlockReason,
    refetchTracks,
    selectedTrackUId,
    setSelectedTrackUId,
    showTrackSelectionModal,
    setShowTrackSelectionModal,
    handleTrackSelectionConfirm,
    erealtyIframeOpenCommentModal,
    setErealtyIframeOpenCommentModal,
    erealtyIframeComment,
    setErealtyIframeComment,
    erealtyIframePayload,
    handleErealtyIframeConfirm,
  } = useEditStatusForm({
    status,
    handleConfirmUpdate,
    onOpenCreateTrack,
  });

  const { lead } = useContext(LeadPageContext);
  const mobileNumberRequired = isStatusBlockedWithoutPhone(
    selectedStatus?.requiresMobileNumber &&
      selectedStatus?.uid !== lead?.data?.lead?.status?.id,
    lead?.data?.lead?.lead_telephones,
    lead?.data?.lead?.do_not_call,
  );

  return (
    <>
      <TrackSelectionModal
        open={showTrackSelectionModal}
        onClose={() => {
          setShowTrackSelectionModal(false);
        }}
        tracks={tracks}
        selectedTrackUId={selectedTrackUId}
        onSelectTrack={(trackUId) => {
          setSelectedTrackUId(trackUId);
        }}
        onConfirm={() => {
          handleTrackSelectionConfirm();
        }}
        isLoading={isLoadingTracks || isLoadingSubmition}
        title="Select Property Track"
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: "100%",
          minHeight: "fit-content",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 1,
            minHeight: "fit-content",
          }}
        >
          <StatusSelector
            data={status?.data?.data}
            handleChangeStatus={status?.handleChangeStatus}
            setStatusFormUId={setStatusFormUId}
          />
        </Box>
        {mobileNumberRequired ? (
          <StatusMobileNumberNotice />
        ) : isLoadingForm ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              backgroundColor:
                muiTheme.colorSchemes.light.palette.background.white,
              minHeight: "fit-content",
            }}
          >
            <FormRenderer
              statusName={status.statusName}
              selectedStatus={selectedStatus}
              handleSubmit={handleSubmit}
              isLoadingSubmition={isLoadingSubmition || disableSaveForTrack}
              handleClose={() => status.setEditLeadStatusModalOpen(false)}
              formFields={formFields}
              status={status}
              getSaleType={getSaleType}
              handleDeleteFile={handleDeleteFile}
              handleFiles={handleFiles}
              files={files}
              paymentFiles={paymentFiles}
              paymentPlanFiles={paymentPlanFiles}
              handlePaymentFiles={handlePaymentFiles}
              handlePaymentPlanFiles={handlePaymentPlanFiles}
              handleDeletePaymentFiles={handleDeletePaymentFiles}
              erealtyIframeOpenCommentModal={erealtyIframeOpenCommentModal}
              setErealtyIframeOpenCommentModal={
                setErealtyIframeOpenCommentModal
              }
              erealtyIframeComment={erealtyIframeComment}
              setErealtyIframeComment={setErealtyIframeComment}
              handleErealtyIframeConfirm={handleErealtyIframeConfirm}
              erealtyIframePayload={erealtyIframePayload}
            />
          </Box>
        )}
        {trackBlockReason === "loading" && (
          <Alert severity="info" sx={{ width: "100%" }}>
            Loading property tracks…
          </Alert>
        )}
        {trackBlockReason === "error" && (
          <Alert
            severity="error"
            sx={{ width: "100%" }}
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => refetchTracks()}
              >
                Retry
              </Button>
            }
          >
            Couldn't load property tracks. Saving is disabled until they load.
          </Alert>
        )}
      </Box>
    </>
  );
};

export default EditStatusForm;
